import { useMemo } from "react"
import { useQuery } from "urql"

import "../graphql/customerSearch"
import { SALES_SEARCH_LIMIT, SUGGESTION_DEBOUNCE_MS } from "../constants"
import type { SalesCustomer } from "../types"

import { GetSalesCustomerListDocument } from "@/graphql/codegen/graphql"
import { COMPANY_TYPE } from "@/screens/Companies/constants"
import useDebounce from "@/utils/useDebounce"

const SALES_CUSTOMER_COMPANY_TYPES = [COMPANY_TYPE.CUSTOMER]

interface UseGetSalesCustomerSuggestionsReturn {
  suggestions: SalesCustomer[]
}

export const useGetSalesCustomerSuggestions = (searchInputValue: string): UseGetSalesCustomerSuggestionsReturn => {
  const debouncedQuery = useDebounce(searchInputValue.trim(), SUGGESTION_DEBOUNCE_MS)

  const [{ data }] = useQuery({
    query: GetSalesCustomerListDocument,
    variables: {
      input: {
        searchTerm: debouncedQuery || undefined,
        companyTypes: SALES_CUSTOMER_COMPANY_TYPES,
        limit: SALES_SEARCH_LIMIT,
        offset: 0,
      },
    },
    pause: debouncedQuery.length < 2,
  })

  const suggestions = useMemo<SalesCustomer[]>(() => {
    if (data?.location?.listBillingLocations?.__typename === "BillingLocationListSuccess") {
      return data.location.listBillingLocations.billingLocations
    }
    return []
  }, [data])

  return { suggestions }
}
